import Cookie from 'js-cookie'

$(document).ready(function() {
    if (!Cookie.get('cookies_accepted')) {
        $('.cookie-popup').addClass('show');
    }

    $('.cookie-popup .accept').on('click', function() {
        Cookie.set('cookies_accepted', true, { expires: 365 });
        $('.cookie-popup').removeClass('show');
    });
});
